import React from 'react'

export function SkeletonTextarea() {
  return <div className='c-skeleton c-skeleton--textarea'></div>
}
